import React, {useEffect, useMemo, useState} from 'react';
import { ReactComponent as StripeLogo } from '../svg/filled/stripe.svg';
import { ReactComponent as PayPalLogo } from '../svg/filled/paypal.svg';
import { connect } from 'react-redux';
import {checkout, initializeCheckoutSession} from '../redux/actions/checkout';
import {
    checkoutLoading, pagesClientSecretListSelector,
    pagesClientSecretRequestSelector,
    pagesShowCheckoutFormSelector,
    sessionKey
} from '../redux/selectors/pagesSelectors';
import { cartMainProduct, cartRenewSelector } from '../redux/selectors/cartSelector';
import { PAYMENT_PAYPAL_ENABLED } from '../constants/constants';
import {setProceedToCheckoutAfterAuth} from '../redux/actions/pagesActions';
import CheckoutForm from "./CheckoutForm";
import useTotalNumber from "../hooks/useTotalNumber";
import {loadStripe} from "@stripe/stripe-js";
import {authEmailSelector} from "../redux/selectors/authSelectors";
import {STRIPE_PUBLIC_KEY} from "../general/config";

function Cards({
                   checkout,
                   checkoutLoading,
                   cartRenew,
                   sessionKey,
                   setAccountFormIsVisible,
                   setProceedToCheckoutAfterAuth,
                   pagesClientSecretRequest,
                   pagesShowCheckoutForm,
                   initializeCheckout,
                   clientSecretList
               }) {

    const totalNumber = useTotalNumber();

    const pagesClientSecret = useMemo(() => {
        if (!clientSecretList || !totalNumber || !sessionKey) {
            return null;
        } else {
            const cartRenewText =  cartRenew || false;
            return clientSecretList.find(item => item.key === totalNumber + cartRenewText.toString())?.clientSecret;
        }
    }, [clientSecretList, totalNumber, sessionKey, cartRenew]);


    useEffect(() => {
        if (totalNumber && sessionKey) {
            if (clientSecretList && !pagesClientSecret) {
                initializeCheckout(totalNumber);
            }
        }
    }, [totalNumber, clientSecretList, !pagesClientSecret, sessionKey, cartRenew]);

    const [stripe, setStripe] = useState(null);

    useEffect(() => {
        if (!stripe) {
            const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);
            stripePromise.then(setStripe);
        }
    }, []);

    const handleStripe = () => {
        setAccountFormIsVisible(true);
        setProceedToCheckoutAfterAuth('stripe');
    };

    const handlePayPal = () => {
        if (sessionKey) {
            checkout('paypal');
        } else {
            setAccountFormIsVisible(true);
            setProceedToCheckoutAfterAuth('paypal');
        }
    };

    const checkoutTitleStripe = cartRenew
        ? 'Subscribe to the service using a credit/debit card'
        : 'Make a one time credit/debit card payment';

    const checkoutTitlePayPal = cartRenew
        ? 'Subscribe to the service using PayPal'
        : 'Make a one time PayPal payment';

    return (
        <>
            <div className={'card__main'}>
                {sessionKey ?
                    <>
                        {totalNumber && pagesShowCheckoutForm && !pagesClientSecretRequest && pagesClientSecret &&
                        <CheckoutForm
                            key={pagesClientSecret}
                            stripe={stripe}
                            pagesClientSecret={pagesClientSecret}
                        />}
                    </>
                    :
                    <>
                        <div className={'card__container'}>
                            <div className={''}>
                                <h3 className={'card__title'}>{checkoutTitleStripe}</h3>
                                <span className={'card__description'}>
                            It may take up to 5 minutes for the payment process
                        </span>
                            </div>
                            <div className={'card__item'}>
                                <StripeLogo className={'card__logo'} />
                            </div>
                            <div className={'card__item'}>
                                <button
                                    disabled={checkoutLoading}
                                    onClick={() => handleStripe()}
                                    type={'button'}
                                    className={'button card__button button--proceed'}
                                >
                                    <span className={'text-2 bold'}>Pay Now</span>
                                </button>
                            </div>
                        </div>
                    </>
                }
                <div className={'card__or'}>OR</div>
                <div className={`card__list card__list${PAYMENT_PAYPAL_ENABLED ? '' : '--single'}`}>
                    {!!PAYMENT_PAYPAL_ENABLED && (
                        <div className={'card__container'}>
                            <div className={''}>
                                <h3 className={'card__title'}>{checkoutTitlePayPal}</h3>
                                <span className={'card__description'}>
                                It may take up to 5 minutes for the payment process
                            </span>
                            </div>
                            <div className={'card__item'}>
                                <PayPalLogo className={'card__logo'} />
                            </div>
                            <div className={'card__item'}>
                                <button
                                    disabled={checkoutLoading}
                                    onClick={() => handlePayPal()}
                                    type={'button'}
                                    className={'button card__button button--proceed'}
                                >
                                    <span className={'text-2 bold'}>Pay Now</span>
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className={'notification__message mb-60 mt-0'}>
                If you are not 100% satisfied with your purchase, within 60 days from the purchase
                date, we will fully refund the cost of your order.
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    mainProduct: cartMainProduct(state),
    checkoutLoading: checkoutLoading(state),
    cartRenew: cartRenewSelector(state),
    sessionKey: sessionKey(state),
    pagesClientSecretRequest: pagesClientSecretRequestSelector(state),
    pagesShowCheckoutForm: pagesShowCheckoutFormSelector(state),
    clientSecretList: pagesClientSecretListSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    checkout: (provider) => dispatch(checkout(provider)),
    setProceedToCheckoutAfterAuth: (provider) => dispatch(setProceedToCheckoutAfterAuth(provider)),
    initializeCheckout: (totalNumber) => dispatch(initializeCheckoutSession(totalNumber)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Cards);

